import "./bootstrap";
import "bootstrap";
import jQuery from "jquery";
import { createApp, h } from "vue";
import { Inertia } from "@inertiajs/inertia";
import { InertiaProgress } from "@inertiajs/progress";
import SvgVue from "svg-vue3";
import { trans, setLocale, transChoice } from "matice";

window.$ = window.jQuery = jQuery;

// eslint-disable-next-line @typescript-eslint/no-require-imports
require("./Plugins/scrollTo");
// eslint-disable-next-line @typescript-eslint/no-require-imports
const { createInertiaApp } = require("@inertiajs/inertia-vue3");

// setLocale(app.config.locale);
setLocale("de");

createInertiaApp({
    // eslint-disable-next-line @typescript-eslint/no-require-imports
    resolve: (name: string) => require(`./Pages/${name}`).default,
    setup({ el, app, props, plugin }) {
        const vueApp = createApp({ render: () => h(app, props) });

        vueApp.config.globalProperties.route = route as typeof route;
        vueApp.config.globalProperties.$trans = trans as typeof trans;
        vueApp.config.globalProperties.$transChoice = transChoice as typeof transChoice;

        vueApp.use(plugin).use(SvgVue).mount(el);
    },
});

Inertia.on("success", () => {
    window.scrollTo({
        top: 0,
        left: 0,
        behavior: "auto",
    });
});

InertiaProgress.init({ color: "#4B5563" });
